import { render, staticRenderFns } from "./SanctionsPage.vue?vue&type=template&id=159f0c6e&scoped=true"
import script from "./SanctionsPage.vue?vue&type=script&lang=js"
export * from "./SanctionsPage.vue?vue&type=script&lang=js"
import style0 from "./SanctionsPage.vue?vue&type=style&index=0&id=159f0c6e&prod&scoped=true&lang=css"
import style1 from "./SanctionsPage.vue?vue&type=style&index=1&id=159f0c6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159f0c6e",
  null
  
)

export default component.exports